import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import UserDatabases from '@Services/UserDatabases';
import { ButtonWithIcon } from '@els/els-react--button';
import './HeaderContainer.scss';
import HeaderContainerService from './HeaderContainerService';
import { checkChildrenValues } from './disableButtonHelper';

function HeaderContainer({ nodesList, properties }) {
  const dbs = UserDatabases.getUserSearchContexts();
  const [disabledState, setDisabledState] = useState(true);

  useEffect(() => {
    setDisabledState(checkChildrenValues(nodesList));
  }, [nodesList]);

  function searchInDb(db) {
    return HeaderContainerService.searchInDb(db, nodesList, properties);
  }

  useEffect(() => {
    HeaderContainerService.init();
  }, []);

  return (
    <div className="qb-header-container" aria-labelledby="qb-header-container-label">
      <span id="qb-header-container-label" className="qb-header-container__label">
        Search in:
      </span>
      <div className="qb-header-container__button">
        {dbs &&
          dbs.length > 0 &&
          dbs.map((db) => (
            <ButtonWithIcon
              iconRight
              key={db.serverAlias}
              aria-label={`Search in ${db.displayName}`}
              data-e2e={`querybuilder-${db.displayName?.toLowerCase()}-button`}
              disabled={disabledState}
              htmlType="submit"
              sprite="ChevronRight"
              onClick={() => {
                searchInDb(db);
              }}>
              {db.displayName}
            </ButtonWithIcon>
          ))}
      </div>
    </div>
  );
}

HeaderContainer.propTypes = {
  nodesList: PropTypes.array,
  properties: PropTypes.array,
};
export default HeaderContainer;
